import type { LinkDef } from '@hanzo/ui/types'

export default [
  {
    title: 'Ecosystem',
    href: 'https://lux.link',
    variant: 'linkFG'
  },
  {
    title: 'Lux AI',
    href: 'https://lux.chat',
  },
  {
    title: 'Lux Credit',
    href: 'https://lux.credit',
  },
  {
    title: 'Lux Exchange',
    href: 'https://lux.exchange',
  },
  {
    title: 'Lux Finance',
    href: 'https://lux.finance',
  },
  {
    title: 'Lux Market',
    href: 'https://lux.market',
  },
  {
    title: 'Lux Shop',
    href: 'https://lux.shop',
  },
  {
    title: 'Lux Quest',
    href: 'https://lux.quest',
  },
] satisfies LinkDef[]
